import React from 'react'
import { T } from '@transifex/react'
import { FormRule } from 'antd'
import { isValidPhoneNumber } from 'react-phone-number-input'

import { TLocationValue } from 'src/mapbox/components/LocationInput'
import isValidEmail from 'src/utils/isValidEmail'
import { jsxFieldRequried, jsxInvalidEmail } from 'src/utils/yup-validation'

const phoneValidation = (v: string) => {
  if (!v?.length) return true
  return isValidPhoneNumber(v)
}

export const VALIDATION_HELPERS = {
  phoneValidation,
}

const INVALID_PHONE_NUMBER = <T _str="Please enter a valid phone number." />
const INVALID_LOCATION = <T _str="Please select address" />

export const VALIDATION_MESSAGES = { INVALID_PHONE_NUMBER }

export const VALIDATORS = {
  phone: {
    validator: (_, v) =>
      VALIDATION_HELPERS.phoneValidation(v)
        ? Promise.resolve()
        : Promise.reject(),
    message: INVALID_PHONE_NUMBER,
  },
  required: { required: true, message: jsxFieldRequried },
  hostName: {
    pattern:
      // eslint-disable-next-line no-useless-escape
      /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?)$/,
  },
  location: {
    validator: (_, value: TLocationValue) => {
      if (
        value?.name !== undefined &&
        value?.latitude !== undefined &&
        value?.longitude !== undefined
      ) {
        return Promise.resolve()
      }
      return Promise.reject()
    },
    message: INVALID_LOCATION,
  },
  email: {
    validator: (_, email) => {
      if (email && !isValidEmail(email)) {
        return Promise.reject()
      }

      return Promise.resolve()
    },
    message: jsxInvalidEmail,
  },
  emails: {
    validator: (_, emails) => {
      if (emails) {
        // eslint-disable-next-line no-restricted-syntax
        for (const email of emails) {
          if (!isValidEmail(email)) {
            return Promise.reject()
          }
        }
      }

      return Promise.resolve()
    },
    message: jsxInvalidEmail,
  },
} satisfies Record<string, FormRule>
